@if (service.entries().length > 0) {
  <div class="undo-snackbar-container" role="status" aria-live="polite">
    @for (entry of service.entries(); track entry.id) {
      <div
        class="undo-entry"
        [class.undo-entry--leaving]="entry.closing()"
        [class.undo-entry--cancelled]="entry.cancelled()"
        [style.--undo-duration.ms]="entry.durationMs"
        (keydown.escape)="confirmNow(entry.id)"
      >
        <!-- Minuteur : la tasse se vide sur toute la durée d'annulation.
             Décoratif (le libellé et le bouton portent l'information). -->
        <svg class="undo-cup" viewBox="0 0 24 24" aria-hidden="true">
          <defs>
            <clipPath [attr.id]="'undo-cup-' + entry.id">
              <path d="M5.2 9h11.6l-1 8.2a2.6 2.6 0 0 1-2.6 2.3H8.8a2.6 2.6 0 0 1-2.6-2.3z" />
            </clipPath>
          </defs>
          <g [attr.clip-path]="'url(#undo-cup-' + entry.id + ')'">
            <path class="undo-cup__coffee" d="M3 9.6q2.2-1.1 4.5 0t4.5 0 4.5 0 4.5 0V22H3z" />
          </g>
          <path class="undo-cup__shape" d="M5.2 9h11.6l-1 8.2a2.6 2.6 0 0 1-2.6 2.3H8.8a2.6 2.6 0 0 1-2.6-2.3zM16.6 11h1.2a2.1 2.1 0 0 1 0 4.2h-1.6" />
          <path class="undo-cup__steam" d="M9 6.4c-.7-.8.7-1.6 0-2.6M12.6 6.4c-.7-.8.7-1.6 0-2.6" />
        </svg>

        <span class="undo-entry__label">{{ entry.label }}</span>

        <button
          type="button"
          class="undo-entry__cancel"
          (click)="cancel(entry.id)"
          [attr.aria-label]="'Annuler la suppression : ' + entry.label"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 14 4 9l5-5" />
            <path d="M4 9h10.5a5.5 5.5 0 0 1 0 11H11" />
          </svg>
          Annuler
        </button>

        <!-- Confirmer tout de suite : coche, sans attendre la fin du délai. -->
        <button
          type="button"
          class="undo-entry__confirm"
          (click)="confirmNow(entry.id)"
          [attr.aria-label]="'Supprimer maintenant : ' + entry.label"
          title="Supprimer maintenant"
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 12.5 10 17.5 19 7" />
          </svg>
        </button>

        <!-- Liseré orange qui s'écoule de droite à gauche : même minuteur, lecture périphérique. -->
        <span class="undo-entry__drain" aria-hidden="true"></span>
      </div>
    }
  </div>
}
